<section class="h-5/6" [ngClass]="['Jotto Web'].includes(app) ? 'h-full' : 'h:5/6'">
	<div class="py-8 px-4 mx-auto my-auto max-w-screen-xl lg:py-16 lg:px-6 lg:h-full xl:h-full flex flex-col justify-center" [ngClass]="['Jotto Web'].includes(app) ? 'h-full' : 'lg:h-full xl:h-full'">
		<div class="mx-auto max-w-screen-sm text-center justify-center">
			<p class="mb-4 text-9xl font-bold text-portals-primary-900 md:text-9xl dark:text-white">404</p>
			<p class="mb-4 text-3xl font-bold text-gray-900 md:text-4xl dark:text-white">Something's missing.</p>
			<p class="mb-4 text-lg font-light text-gray-500 dark:text-gray-400">Sorry, we can't find that page. Looking for something else?</p>
		</div>
		<div class="space-y-8 my-4 md:grid md:grid-cols-1 lg:grid-cols-3 md:gap-12 md:space-y-0 place-items-center">
			<ng-container *ngIf="!['Jotto Web'].includes(app)">
				<a routerLink="/dashboard/analytics" class="bg-gray-100 shadow-md p-6 lg:w-full md:w-3/6 sm:w-9/12 text-center rounded-lg flex flex-col justify-center hover:cursor-pointer">
					<div class="w-full flex flex-row justify-center mb-4 text-center">
						<div class="bg-portals-primary-50 rounded-lg h-12 w-12 flex flex-col justify-center text-center">
							<svg class="h-6 w-full text-portals-theme-preview-background-600" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 17 18">
								<path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M1 12v5m5-9v9m5-5v5m5-9v9M1 7l5-6 5 6 5-6" />
							</svg>
						</div>
					</div>
					<h2 class="mb-2 text-xl">Analytics</h2>
				</a>
			</ng-container>
			<ng-container *ngIf="['Jotto'].includes(app)">
				<a routerLink="/dashboard/jotts" class="bg-gray-100 shadow-md p-6 lg:w-full md:w-3/6 sm:w-9/12 text-center rounded-lg flex flex-col justify-center hover:cursor-pointer">
					<div class="w-full flex flex-row justify-center mb-4 text-center">
						<div class="bg-portals-accent-50 rounded-lg h-12 w-12 flex flex-col justify-center text-center">
							<svg class="h-6 w-full text-portals-theme-status-pending" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 18">
								<path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 1v11m0 0 4-4m-4 4L4 8m11 4v3a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2v-3" />
							</svg>
						</div>
					</div>
					<h2 class="mb-2 text-xl">Jott Responses</h2>
				</a>
			</ng-container>
			<ng-container *ngIf="['Mobile Justice', 'Y-Stop', 'Alliance'].includes(app)">
				<a routerLink="/dashboard/incidents" class="bg-gray-100 shadow-md p-6 lg:w-full md:w-3/6 sm:w-9/12 text-center rounded-lg flex flex-col justify-center hover:cursor-pointer">
					<div class="w-full flex flex-row justify-center mb-4 text-center">
						<div class="bg-portals-accent-50 rounded-lg h-12 w-12 flex flex-col justify-center text-center">
							<svg class="h-6 w-full text-portals-theme-status-pending" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 18">
								<path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 1v11m0 0 4-4m-4 4L4 8m11 4v3a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2v-3" />
							</svg>
						</div>
					</div>
					<h2 class="mb-2 text-xl">Incidents</h2>
				</a>
			</ng-container>
			<ng-container *ngIf="['Jotto'].includes(app)">
				<a routerLink="/dashboard/prompts" class="bg-gray-100 shadow-md p-6 lg:w-full md:w-3/6 sm:w-9/12 text-center rounded-lg flex flex-col justify-center hover:cursor-pointer">
					<div class="w-full flex flex-row justify-center mb-4 text-center">
						<div class="bg-portals-primary-50 rounded-lg h-12 w-12 flex flex-col justify-center text-center">
							<svg class="h-6 w-full text-portals-theme-preview-background-600" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16">
								<path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 12V1m0 0L4 5m4-4 4 4m3 5v3a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2v-3" />
							</svg>
						</div>
					</div>
					<h2 class="mb-2 text-xl">Jott Prompts</h2>
				</a>
			</ng-container>
			<ng-container *ngIf="['Mobile Justice', 'Y-Stop', 'Alliance'].includes(app)">
				<a routerLink="/dashboard/notifications" class="bg-gray-100 shadow-md p-6 lg:w-full md:w-3/6 sm:w-9/12 text-center rounded-lg flex flex-col justify-center hover:cursor-pointer">
					<div class="w-full flex flex-row justify-center mb-4 text-center">
						<div class="bg-portals-primary-50 rounded-lg h-12 w-12 flex flex-col justify-center text-center">
							<svg class="h-6 w-full text-portals-theme-preview-background-600" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16">
								<path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 12V1m0 0L4 5m4-4 4 4m3 5v3a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2v-3" />
							</svg>
						</div>
					</div>
					<h2 class="mb-2 text-xl">Notifications</h2>
				</a>
			</ng-container>
		</div>
		<div class="mx-auto max-w-screen-sm text-center justify-center">
			<a routerLink=".." class="inline-flex text-white bg-portals-primary-900 hover:bg-portals-primary-500 font-medium rounded-lg text-sm px-5 py-2.5 text-center my-4">Or go back to previous page</a>
		</div>
	</div>
</section>
